export const PLP_EVENTS = {
  MP_TITPTILE_CLICKED: 'tiptile_clicked',
  MP_PLP_FIRST_CLICK_INTERACTION: 'plp_first_click_interaction',
  MP_PLP_FIRST_CLICK_INTERACTION_NEW: 'plp_first_interaction_new',
  VIEW_SIMILAR_CLICKS: 'view_similar_clicks',
  SEARCH_PAGELOAD: 'search_listing_loads',
  CATEGORY_PAGELOAD: 'category_listing_loads',
  FILTER_APPLIED: 'filter_applied',
  SORT_APPLIED: 'sort_applied',
  QUICK_FILTERS_SHOWN: 'plp_quick_filters_shown',
  QUICK_FILTER_SELECTED: 'plp_quick_filters_selected',
  QUICK_FILTER_UNSELECTED: 'plp_quick_filters_unselected',
  CAROUSEL_FIRST_IMAGE_SWIPED: 'plp_image_swiped',
};

export const PLP_INTERACTION = {
  PRODUCT: 'productImageCard',
  VIEW_SIMILAR: 'viewSimilar',
  WISHLIST: 'wishlist',
  TIP_TILE: 'tipTile',
};

export const SEARCH = 'search';

export const BRAND_LISTING_PAGE = 'brandListingPage';
export const CATEGORY_LISTING_PAGE = 'categoryListingPage';
